import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { TMailFactory } from './types';

/**
 * Create Lead Quote Mail Factory
 *
 * @param {*} lead
 * @param {*} vehicleServiceClient
 * @return {TMailBody} { subject: string, message: string }
 */
export const createLeadQuoteMail: TMailFactory = (lead, vehicleServiceClient) => {
    const { name, version } = lead;
    const vehicle = vehicleServiceClient || lead.vehicle;
    const year = vehicleServiceClient?.year || lead.year;

    return {
        subject: `Cotización de ${vehicle?.make?.name} ${vehicle?.model} ${year}`,
        message: `Estimado ${capitalize(
            name
        )}, aquí le hago llegar toda la información del modelo ${capitalize(
            vehicle?.model
        )}${version?.name ? ' - ' + version?.name : ''
            } ${year} del cual está usted interesado.`,
    };
};
